import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/images/minicity_logo.png'


const _hoisted_1 = {
  key: 1,
  class: "fullscreenCenteredContainer"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mb-3"
}, null, -1)
const _hoisted_3 = { class: "notification bulmaNotification is-danger" }

import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { tryToResumeSession, chromeless } from "./core/session";
import { loadConfig, CONFIG, MaintenanceMode } from "./core/config";
import router from "./router";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const initializing = ref<boolean>(true);

const route = useRoute();

onMounted(async () => {

  loadConfig();

  await useRouter().isReady();

  // The portal can be launched "chromeless" - e.g. when embedded within the tablet app
  // Store that state, so the rest of the app can refer to it
  if (route.query.chromeless?.toString() == "true") {
    chromeless.value = true;
  }

  // When embedded within the tablet app, we can inherit its session
  if (route.query.sessionId) {
    // Remove sessionId URL query param, so if the user shares a link, their session won't be leaked
    const url = new URL(window.location.toString());
    url.searchParams.delete('sessionId');    
    window.history.replaceState({}, '', url);

    // Try to resume indicated session
    tryToResumeSession(route.query.sessionId.toString())
      .catch((err) => {
        console.error("sessionId parameter was not valid - need to login");
        router.push(`/login?forwardTo=${encodeURIComponent(document.location.pathname + document.location.search)}`);
      })
      .finally(() => {
        initializing.value = false;
      });
  } else {
    // Try to resume cached session, if any
    tryToResumeSession()
      .catch(err => {
        // Swallow session-resume errors - it's not unusual to encounter e.g. an expired session
        console.log("Failed to resume session");
      })
      .finally(() => {
        initializing.value = false;
      });
  }
});


return (_ctx: any,_cache: any) => {
  const _component_LoadingPage = _resolveComponent("LoadingPage")!
  const _component_router_view = _resolveComponent("router-view")!

  return (initializing.value || !_unref(CONFIG))
    ? (_openBlock(), _createBlock(_component_LoadingPage, { key: 0 }))
    : (_unref(CONFIG).maintenanceMode == _unref(MaintenanceMode).CLOSED)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(CONFIG).maintenanceMessage), 1)
        ]))
      : (_openBlock(), _createBlock(_component_router_view, { key: 2 }))
}
}

})